/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { XLargeText, XXXLargeText } from '../styles/styles';


const TableValue = styled('span')`
  text-align: center;
  ${XXXLargeText};
`;


const TableLabel = styled('span')`
  text-align: center;
  ${XLargeText};
`;

const StatSummaryContainer = css`
  display: flex; 
  align-items: center; 
  flex-direction: column;
`;

export default class StatSummary extends React.PureComponent<{
  label: string;
  value: string | number;
}> {
  public render() {
    return (
      <div css={StatSummaryContainer}>
        <TableValue title={this.props.label} >{this.props.value}</TableValue>
        <TableLabel>{this.props.label}</TableLabel>
      </div>
    )
  }
}
